import { CSSProperties, ElementType, FC } from "react";
import { useTheme } from "@mui/material";

const TableRowDivider: FC<{ sx?: CSSProperties; component?: ElementType }> = ({
  sx,
  component: Component = "hr",
}) => {
  const {
    palette: { mode },
  } = useTheme();

  const color = mode === "light" ? "#0000002e" : "#ffffff2e";

  return (
    <Component
      style={{
        margin: 0,
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderBottomWidth: "min(0.2vw, 2px)",
        alignSelf: "stretch",
        height: "auto",
        borderImage: `linear-gradient(to right, #ffffff00 0%, ${color} 30%, ${color} 70%, #00000000 100%) 1`,
        ...sx,
      }}
    />
  );
};

export default TableRowDivider;
